export default __webpack_public_path__ + "static/media/02-empathy-map.27a57775.png";